import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

export default function Contact() {
  const [form, setForm] = useState({
    your_name: "",
    email_address: "",
    phone_number: "",
    company_name: "",
    your_message: ""
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("https://api.bytlas.com/api/contact", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(form)
    });

    const result = await response.json();

    if (response.ok) {
      swal({
        title: "Thank You! ",
        text: "Your message has been sent successfully. Our team will contact you soon.",
        icon: "success",
        button: "OK"
      });

      // Reset form
      setForm({
        your_name: "",
        email_address: "",
        phone_number: "",
        company_name: "",
        your_message: ""
      });

      // Optional redirect after delay
      setTimeout(() => {
        navigate("/Dashboard");
      }, 2000);

    } else {
      swal({
        title: "Oops!",
        text: result.message || "Something went wrong. Please try again.",
        icon: "error",
        button: "OK"
      });
    }

  } catch (error) {
    swal({
      title: "Error!",
      text: "Server not responding. Please try again later.",
      icon: "error",
      button: "OK"
    });
  }
};

  return (
    <section id="contact" className="py-5" style={{ marginTop: "75px" }}>
      
      <div className="container">
        <div className="row text-center mb-4">
          <h2 className="display-2 fw-bold">Have Some <span className="text-primary">Questions?</span></h2>
          <p className="text-muted">We'd love to hear from you!</p>
          <hr className="w-20 mx-auto" />
        </div>
        
        <div className="row g-4">
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            <img src="/assets/contact.png" alt="Contact" className="img-fluid rounded shadow" style={{ maxWidth: '90%' }} />
          </div>

          <div className="col-md-6">
            <form onSubmit={handleSubmit} className="bg-light p-4 rounded shadow-sm">
              <div className="mb-3">
                <label htmlFor="your_name" className="form-label">Your Name</label>
                <input type="text" name="your_name" id="your_name" className="form-control" placeholder="John Doe" value={form.your_name} onChange={handleChange} required />
              </div>

              <div className="mb-3">
                <label htmlFor="email_address" className="form-label">Email Address</label>
                <input type="email" name="email_address" id="email_address" className="form-control" placeholder="you@example.com" value={form.email_address} onChange={handleChange} required />
              </div>

              <div className="mb-3">
                <label htmlFor="phone_number" className="form-label">Phone Number</label>
                <input type="tel" name="phone_number" id="phone_number" className="form-control" placeholder="9876543210" value={form.phone_number} onChange={handleChange} required />
              </div>

              <div className="mb-3">
                <label htmlFor="company_name" className="form-label">Company Name</label>
                <input type="text" name="company_name" id="company_name" className="form-control" placeholder="ABC Pvt. Ltd." value={form.company_name} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label htmlFor="your_message" className="form-label">Your Message</label>
                <textarea name="your_message" id="your_message" className="form-control" rows="5" placeholder="Type your message..." value={form.your_message} onChange={handleChange} required></textarea>
              </div>

              <button type="submit" className="btn btn-primary w-100 rounded-pill">
                Send Message <i className="fa fa-paper-plane ms-2"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-5">
          <iframe
            title="Google Map"
            className="w-100 rounded shadow-sm"
            height="400"
            frameBorder="0"
            allowFullScreen
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7537.553148247047!2d73.11890963110638!3d19.16125492968579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774547619473!5m2!1sen!2sin"></iframe>
        </div>
      </div>
    </section>
  );
}
